module.exports = "../study/imgs/maps/Tokyo/S8/Hazard/Slopefailure/Tokyo_Slopefailure_HadGEM2_RCP85_End.png";